<template>
    <o-table :title="$t('sandoz.kuko_products')" ref="tableList" url="/api/kuko_products?include=group">
        <template slot="filter">
            <div class="float-left">
              <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="false">
                <o-filter-text :title="$t('sandoz.pharma_code')" column="pharma_code"></o-filter-text>
                <o-filter-text :title="$t('sandoz.gln')" column="gln"></o-filter-text>
                <o-filter-text :title="$t('sandoz.product')" column="product"></o-filter-text>
                <o-filter-select :items="productGroups" value-field="id" text-field="product_group" :title="$t('sandoz.product_group')" column="product_group_id"></o-filter-select>
              </o-filter>
            </div>
            <div class="import float-right">
              <b-button class="ml-2" type="button" variant="primary" @click="openImportModal">
                {{  $t('sandoz.product_import') }}
              </b-button>

              <b-modal id="modal-attachment" ref="importModal" :ok-title="$t('core.save')" :ok-disabled="loading" :title="$t('sandoz.product_import')" size="md"
                @ok="save" @show="resetForm" :no-close-on-backdrop="true" :no-close-on-esc="true">
                <template v-if="!loading">
                  <o-file-upload v-model="form.file" :allow-clear="true" :allow-download="false"></o-file-upload>
                  <o-checkbox class="cb" :label="$t('sandoz.clear_existing_records')" v-model="form.clear_existing_records"></o-checkbox>
                </template>
                <template v-else>
                  <div class="d-flex justify-content-center my-2">
                    <span class="spinner-border spinner-border-sm mr-1 text-center" role="status" aria-hidden="true"></span>Importing...
                  </div>
                </template>
              </b-modal>
            </div>

        </template>
        <template slot="head">
            <o-table-header column="pharma_code">{{$t('sandoz.pharma_code')}}</o-table-header>
            <o-table-header column="gln">{{$t('sandoz.gln')}}</o-table-header>
            <o-table-header column="product">{{$t('sandoz.product')}}</o-table-header>
            <o-table-header column="efp">{{$t('sandoz.efp')}}</o-table-header>
            <o-table-header column="product_group_id">{{$t('sandoz.product_group')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.pharma_code }}</td>
            <td>{{ props.item.gln }}</td>
            <td>{{ props.item.product }}</td>
            <td>{{ props.item.efp }}</td>
            <td v-html="(props.item.group && props.item.group.data) ? props.item.group.data.description_scheme : '-'"></td>
        </template>
    </o-table>
</template>
<script>
import axios from "axios";
import Form from 'vform'

export default {
  data: () => ({
    productGroups: [],
    loading: false,
    form: new Form({
      file: null,
      clear_existing_records: false
    })
  }),
  mounted() {
    this.loadProductGroups()
  },
  methods: {
    loadProductGroups() {
      axios.get('/api/kuko_product_groups?per_page=9999').then(response => {
        this.productGroups = response.data.data
      })
    },
    openImportModal () {
      this.$refs.importModal.show()
    },
    save(event) {
      event.preventDefault()
      //if(this.form.file !== null) {
        this.loading = true;
        return axios.post('/api/kuko_products/import', this.form)
        .then(response => {
          this.loading = false;
          this.$refs.importModal.hide() 
          window.location.reload()
        })
        .catch((error) => {
            this.loading = false
            if (error.response.status === 422) {
              this.$notify({
                title: this.$i18n.t('core.validation_error'),
                text: this.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                type: 'error'
              })
              if ('data' in error.response && 'errors' in error.response.data) {
                root.errors = error.response.data.errors
              }
            }
        })
      //}
    },
    resetForm() {
      this.form = {
        file: null,
        clear_existing_records: false
      }
    }
  }
}
</script>

<style>
.cb .custom-checkbox {
  top: -32px !important;
  position: relative;
}

.cb > label {
  margin-left: 30px !important;
}
</style>
